import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { MobileSidebar } from "./MobileSidebar";
import { Sidebar } from "./Sidebar";
import { Banner } from "common/Banner";

export const DashboardLayout: FC = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [sidebar, setSidebar] = React.useState(true);

  return (
    <div className="min-h-screen font-inter">
      <div className="h-screen flex overflow-hidden bg-surface">
        {/* Mobile sidebar */}
        <div className="block lg:hidden">
          <MobileSidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
        </div>

        {/* Static sidebar for desktop — slide in/out */}
        <div
          className={`
            hidden lg:block flex-shrink-0 transition-all duration-300 ease-smooth overflow-hidden
            ${sidebar ? "w-60" : "w-0"}
          `}
        >
          <Sidebar />
        </div>

        {/* Main content */}
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <main className="focus:outline-none overflow-auto h-screen">
            {/* Top bar */}
            <div className="sticky top-0 z-10 bg-surface/80 backdrop-blur border-b border-line px-4 sm:px-6 h-12 flex items-center gap-3">
              {/* Mobile menu toggle */}
              <button
                className="text-ink-secondary hover:text-ink focus:outline-none lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
              </button>

              {/* Desktop sidebar toggle */}
              <button
                className="hidden lg:flex items-center justify-center text-ink-muted hover:text-ink focus:outline-none transition-colors duration-150 rounded-md p-1 hover:bg-surface-muted"
                onClick={() => setSidebar((prev) => !prev)}
                title={sidebar ? "Collapse sidebar" : "Expand sidebar"}
              >
                <span className="sr-only">Toggle sidebar</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-[18px] h-[18px]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 5.25h16.5M3.75 12h16.5m-16.5 6.75h16.5"
                  />
                </svg>
              </button>

              {/* Mobile banner content */}
              <div className="flex-1 lg:hidden">
                <Banner setSidebarOpen={setSidebarOpen} />
              </div>
            </div>

            {/* Page content */}
            <div className="p-4 sm:p-6 lg:p-8 w-full min-w-0 animate-fade-in">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
